import { render, staticRenderFns } from "./ShareLinkModal.vue?vue&type=template&id=2a77e574&scoped=true&"
import script from "./ShareLinkModal.vue?vue&type=script&lang=js&"
export * from "./ShareLinkModal.vue?vue&type=script&lang=js&"
import style0 from "./ShareLinkModal.vue?vue&type=style&index=0&id=2a77e574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a77e574",
  null
  
)

export default component.exports